import AccountInfoComponent from './account-info.component';
import { ChangePasswordComponent, changePasswordActions, changePasswordReducer, ForgotPasswordComponent, forgotPasswordActions,
  forgotPasswordReducer, ResetPasswordComponent, SetPasswordComponent,resetPasswordActions, resetPasswordReducer } from './password';
import { ChangeEmailComponent, changeEmailActions, changeEmailReducer } from './email';

export {
  AccountInfoComponent,
  ChangePasswordComponent,
  changePasswordActions,
  changePasswordReducer,
  ForgotPasswordComponent,
  forgotPasswordActions,
  forgotPasswordReducer,
  ResetPasswordComponent,
  SetPasswordComponent,
  resetPasswordActions,
  resetPasswordReducer,
  ChangeEmailComponent,
  changeEmailActions,
  changeEmailReducer,
}



// WEBPACK FOOTER //
// src/acct/index.js